export function isEmail(value) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value || "").trim());
}

export function isPhone(value) {
  const cleaned = String(value || "")
    .trim()
    .replace(/[^\d+]/g, "");
  return cleaned.length >= 8 && cleaned.length <= 20;
}

export function required(value) {
  return String(value || "").trim().length > 0;
}
